import React, { useEffect, useRef, useState } from 'react';
import { Input, Space } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import { string, func, number } from 'prop-types';
import JiraLinkCard from './nested/JiraLinkCard';
import JiraCreateButton from './nested/JiraCreateButton';

const JIRA_ISSUE_KEY_REGEX = /^https?:\/\/\S+\/browse\/(?<key>[A-Z][A-Z0-9]+-\d+)/i;

const extractIssueKey = (url) => url.match(JIRA_ISSUE_KEY_REGEX)?.groups.key.toUpperCase() ?? null;

const JiraLinkField = ({
  value = '', onChange = () => {}, id = '', ticketId = null,
}) => {
  const issueKey = extractIssueKey(value);
  const [isEditing, setIsEditing] = useState(!issueKey);
  const inputRef = useRef(null);
  const focusAfterEdit = useRef(false);

  useEffect(() => {
    if (!isEditing || !focusAfterEdit.current) return;

    inputRef.current?.focus();
    focusAfterEdit.current = false;
  }, [isEditing]);

  const startEditing = () => {
    focusAfterEdit.current = true;
    setIsEditing(true);
  };

  if (issueKey && !isEditing) {
    return <JiraLinkCard url={value} issueKey={issueKey} onEdit={startEditing} />;
  }

  const handleCreated = (url) => {
    onChange(url);
    setIsEditing(false);
  };

  return (
    <Space.Compact block>
      <Input
        ref={inputRef}
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setIsEditing(!extractIssueKey(value))}
        prefix={<LinkOutlined />}
        placeholder={I18n.t('tickets.form.jira_link_hint')}
        allowClear
      />
      {ticketId && !value && (
        <JiraCreateButton ticketId={ticketId} onCreated={handleCreated} />
      )}
    </Space.Compact>
  );
};

JiraLinkField.propTypes = {
  value: string,
  onChange: func,
  id: string,
  ticketId: number,
};

export default JiraLinkField;
